import type { UserState } from '@app/store/user'

import type { UserWithAvatar } from './types'

export const ROLE = {
  Visitor: 'Visitor',
  Contact: 'Contact',
  Standard: 'Standard',
  Admin: 'Admin',
  Staff: 'Staff',
  StaffAdmin: 'StaffAdmin',
  Agent: 'Agent',
} as const

export const PURCHASE_GLOBAL_AGENT_PERMISSION =
  'accounts:canPurchaseGlobalAgent'

export const AGENT_WARNING_MESSAGES = {
  avatar: 'Navigation.MyProfile.Warning.AddPicture',
  phone: 'Navigation.MyProfile.Warning.AddPhone',
  spokenLanguages: 'Navigation.MyProfile.Warning.SpokenLanguages',
  biography: 'Navigation.MyProfile.Warning.Biography',
  socialProfiles: 'Navigation.MyProfile.Warning.SocialProfiles',
} as const

export const getProfileAvatarUrl = (userState: UserState): string => {
  const currentUser = userState.currentUser as UserWithAvatar

  return (
    currentUser.avatar ||
    'https://res.listglobally.com/puzzle/Agent_picture_empty'
  )
}

export const getProfileUsername = (userState: UserState): string => {
  return userState.currentUser.fullName || ''
}

export const getProfileEmail = (userState: UserState): string => {
  return userState.currentUser.email || ''
}
